import { Control, Controller, Path, UseControllerProps } from 'react-hook-form';
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  OutlinedTextFieldProps,
  Radio,
  RadioGroup,
} from '@mui/material';

interface PropTypes<T> extends Omit<OutlinedTextFieldProps, 'variant'> {
  name: Path<T>;
  control: Control<any>;
  defaultValue: UseControllerProps['defaultValue'];
  rules?: UseControllerProps['rules'];
  options: { label: string; value: string }[];
  row?: boolean;
}

const ControlledRadioGroupField = <T extends unknown>({
  name,
  control,
  defaultValue,
  rules,
  options,
  row,
  ...props
}: PropTypes<T>) => (
  <Controller
    name={name}
    control={control}
    defaultValue={defaultValue}
    rules={rules}
    render={({ field, fieldState }) => (
      <FormControl component="fieldset" error={!!fieldState.error} fullWidth>
        <FormLabel component="legend">{props.label}</FormLabel>
        <RadioGroup {...field} row={row}>
          {options.map(option => (
            <FormControlLabel
              key={option.value}
              value={option.value}
              control={<Radio />}
              label={option.label}
            />
          ))}
        </RadioGroup>
        {fieldState.error && (
          <p style={{ color: 'red' }}>{fieldState.error.message}</p>
        )}
      </FormControl>
    )}
  />
);

export default ControlledRadioGroupField;
